import { useDataValue, useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let templates = useDataValue({
    context: 'templates',
    viewPath: props.viewPath,
  })
  let template = useDataValue({
    context: 'item',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'appointment_overlay',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let selected = templates.find(item => item.id === template.id) ?? null
    if (selected) {
      submit({
        type: 'setAppointmentTemplate',
        appointment_type_id: selected.id,
        appointment_type_name: selected.name,
        template_id: selected.template_id,
        duration: selected.duration,
        reset: true,
        template_exists_in_location: true,
      })
    }
    if (typeof props.closePopover === 'function') props.closePopover()
  }
}
